import manifest from "mediaManifest.json";

/**
 * The photographs shown on the site, in order.
 *
 * `slug` must match a key in mediaManifest.json, which the image pipeline
 * regenerates (scripts/build-images.sh). Adding a photograph is one line here.
 *
 * Also available and not currently shown: "rise" and "concrete-jungle", the
 * two remaining San Francisco frames.
 */
export const PHOTOS = [
  { slug: "sunset", caption: "Death Star", alt: "Sun breaking through heavy cloud over the Pacific, surf in the foreground." },
  { slug: "car", caption: "Chasing Sunsets", alt: "Golden-hour street seen through a car windshield, palms along the curb." },
  { slug: "court", caption: "Net", alt: "A beach volleyball net strung low, palms and teal umbrellas behind it." },
  { slug: "little-italy", caption: "That's Amore", alt: "The Little Italy sign over a San Diego street, a red convertible passing beneath." },
  { slug: "moon", caption: "And It Went Like", alt: "A full moon rising over beach cottages at dusk, palms in silhouette." },
  { slug: "love-in-chaos", caption: "Love in Chaos", alt: "A crowded street fair in low sun, stalls and umbrellas running down a city block." },
  { slug: "take-a-walk", caption: "Take a Walk", alt: "A wide green meadow ringed by tall trees, people scattered across the grass." },
];

export const FORMATS = manifest.formats;

/** Every width the pipeline produced for this photograph, smallest first. */
export function widthsFor(slug) {
  const photo = manifest.photos[slug];
  if (!photo) throw new Error(`No such photograph in the manifest: ${slug}`);
  return photo.widths;
}

export function aspectFor(slug) {
  const photo = manifest.photos[slug];
  return photo ? photo.aspect : 1.5;
}

export function urlFor(slug, width, format) {
  return `${manifest.base}/${slug}-${width}.${format}`;
}

/** "…-640.avif 640w, …-1280.avif 1280w" — what the browser picks from. */
export function srcSetFor(slug, format) {
  return widthsFor(slug)
    .map((w) => `${urlFor(slug, w, format)} ${w}w`)
    .join(", ");
}

/** A mid-sized JPEG, used as the src every browser understands. */
export function fallbackFor(slug) {
  const widths = widthsFor(slug);
  const width = widths[Math.min(1, widths.length - 1)];
  return urlFor(slug, width, "jpg");
}
